document.addEventListener('click', function (event) {
  var toggle = event.target.closest('cart-drawer [data-discount-toggle]');
  if (toggle) {
    var wrap = toggle.closest('.cart-discount');
    var form = wrap && wrap.querySelector('[data-discount-form]');
    if (form) {
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var input = form.querySelector('[data-discount-input]');
        if (input) input.focus();
      }
    }
    return;
  }

  var apply = event.target.closest('cart-drawer [data-discount-apply]');
  if (apply) {
    var wrap2 = apply.closest('.cart-discount');
    var input2 = wrap2 && wrap2.querySelector('[data-discount-input]');
    if (input2 && input2.value.trim()) {
      var code = input2.value.trim();
      var originalText = apply.textContent;
      apply.disabled = true;
      apply.textContent = '...';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: code,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          apply.disabled = false;
          apply.textContent = originalText;

          if (data.sections) {
            var cartDrawerEl = document.getElementById('CartDrawer');
            if (cartDrawerEl && data.sections['cart-drawer']) {
              var parsed = new DOMParser()
                .parseFromString(data.sections['cart-drawer'], 'text/html')
                .querySelector('.drawer__inner');
              var currentInner = cartDrawerEl.querySelector('.drawer__inner');
              if (parsed && currentInner) {
                currentInner.innerHTML = parsed.innerHTML;
              }
            }

            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections['cart-icon-bubble']) {
              var parsedBubble = new DOMParser()
                .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section');
              if (parsedBubble) bubble.innerHTML = parsedBubble.innerHTML;
            }
          }
        })
        .catch(function () {
          apply.disabled = false;
          apply.textContent = originalText;
        });
    }
    return;
  }

  var addButton = event.target.closest('[data-crosssell-add]');
  if (addButton) {
    event.preventDefault();
    if (addButton.disabled) return;
    var variantId = addButton.dataset.variantId;
    if (!variantId) return;

    var originalText2 = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          addButton.disabled = false;
          addButton.textContent = originalText2;
          return;
        }

        if (data.sections) {
          var cartDrawerEl = document.getElementById('CartDrawer');
          if (cartDrawerEl && data.sections['cart-drawer']) {
            var parsed = new DOMParser()
              .parseFromString(data.sections['cart-drawer'], 'text/html')
              .querySelector('.drawer__inner');
            var currentInner = cartDrawerEl.querySelector('.drawer__inner');
            if (parsed && currentInner) {
              currentInner.innerHTML = parsed.innerHTML;
            }
          }

          var bubble2 = document.getElementById('cart-icon-bubble');
          if (bubble2 && data.sections['cart-icon-bubble']) {
            var parsedBubble2 = new DOMParser()
              .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section');
            if (parsedBubble2) bubble2.innerHTML = parsedBubble2.innerHTML;
          }
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      })
      .catch(function () {
        addButton.disabled = false;
        addButton.textContent = originalText2;
      });
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter') return;
  var input = event.target.closest('cart-drawer [data-discount-input]');
  if (!input) return;
  event.preventDefault();
  var wrap = input.closest('.cart-discount');
  var applyBtn = wrap && wrap.querySelector('[data-discount-apply]');
  if (applyBtn) applyBtn.click();
});
